export const GET_MANUFACTURER = "GET_MANUFACTURER"
export const GET_MANUFACTURER_SUCCESS = "GET_MANUFACTURER_SUCCESS"
export const GET_MANUFACTURER_FAIL = "GET_MANUFACTURER_FAIL"

export const GET_MANUFACTURER_DETAILS = "GET_MANUFACTURER_DETAILS"
export const GET_MANUFACTURER_DETAILS_SUCCESS = "GET_MANUFACTURER_DETAILS_SUCCESS"
export const GET_MANUFACTURER_DETAILS_ERROR = "GET_MANUFACTURER_DETAILS_SUCCESS"
